import api, { ApiPromise } from 'api/client';
import { withResData } from '@ohmsd/utils';
import Route, { RouteParams } from '@ohmsd/utils/Route';

interface ReqOpts<T> {
  data?: T,
  params?: RouteParams,
  query?: RouteParams,
}

interface Conf<D, N = D> {
  transformOut?: (D) => N,
  transformIn?: (D) => N,
  only?: Array<String>,
}

interface Opts<D, N = D> extends Conf<D, N> {
  extend?: { [key: string]: () => ApiPromise<D> },
  route: Route | string,
}

export default class ApiCrud<D = any, N = D> {
  conf: Conf<D, N> = {};
  route: Route = null;

  constructor (opts: Opts<D, N>) {
    const { extend, route, ...conf } = opts;

    this.route = route instanceof Route ? route : new Route(route);
    Object.assign(this.conf, conf);
    Object.assign(this, extend);
  }

  create ({ params, data, query }) {
    if (this.conf.transformOut)
      data = this.conf.transformOut(data);
    const { route: { route } } = this;
    return api.post(
      route,
      data,
      { params, query },
    ).then(withResData(this.conf.transformIn));
  }

  getById ({ params: { id, ..._params }, query }) {
    // const path = this.route.toString({ params: { id, ..._params }, query });
    // return api.get(path).then(withResData(this.conf.transformIn));

    const { route: { route } } = this;
    return api.get(route, { params: { id, ..._params }, query })
      .then(withResData(this.conf.transformIn));
  }

  fetchList ({ params = {}, query = {} } = {}) {
    // const path = this.route.toString({ params, query });
    const { route: { route } } = this;
    const req = api.get(route, { params, query });
    if (this.conf.transformIn)
      return req.then(res => {
        res.data = res.data.map(this.conf.transformIn);
        return res;
      });
    else
      return req;
  }

  update ({ params, data, query }) {
    if (this.conf.transformOut)
      data = this.conf.transformOut(data);
    const { id } = data;
    // const path = this.route.toString({ params: { id, ...params }, query });
    // return api.put(path, data).then(withResData(this.conf.transformIn));

    const { route: { route } } = this;
    return api.put(route, data, { params: { id, ...params }, query })
      .then(withResData(this.conf.transformIn));
  }

  // updateMany ({ params, list, query }) {
  //   const path = this.route.toString({ params, query });
  //   return api.put(path, list);
  // }

  delete ({ params, data, query }) {
    const id = params?.id || data?.id;
    // const path = this.route.toString({ params: { id, ...params }, query });

    const { route: { route } } = this;
    return api.delete(route, { params: { id, ...params }, query });
  }

  _callProto (method, ...args) {
    return ApiCrud.prototype[method].apply(this, args);
  }
}


